export default {
  BASE_URL: 'psm/vourcher/admin',
  api: [
    {
      name: 'list',
      desc: '获取列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'queryById',
      desc: '获取凭证信息',
      method: 'GET',
      path: '/query'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/psm/qc/voucher.js